import ExcelJS from "exceljs";
class InvalidStructureError extends Error {
}
class BaseExcelDocumentBuilder {
  workbook;
  firstDataRow = 2;
  constructor() {
    this.reset();
  }
  setWorksheet(title, options) {
    this.workbook?.addWorksheet(title, options);
  }
  setColumns(sheetKey, colDefs) {
    const sheet = this.workbook.getWorksheet(sheetKey);
    sheet.columns = colDefs;
  }
  setHeaderStyles(sheetKey) {
    const sheet = this.workbook.getWorksheet(sheetKey);
    const headerRow = sheet.getRow(1);
    headerRow.font = { bold: true };
    this.setHeaderCellBorders(headerRow);
  }
  setValidation(sheetKey, colDefs, maxRow) {
    const sheet = this.workbook.getWorksheet(sheetKey);
    const columnsWithValidation = colDefs.filter((c) => c.validation);
    columnsWithValidation.forEach((c) => this.setColumnValidation(sheet, c, maxRow));
  }
  setData(sheetKey, data) {
    const sheet = this.workbook.getWorksheet(sheetKey);
    sheet.addRows(data);
  }
  parseDataSheet(sheet, columns) {
    const result = [];
    sheet.eachRow((row) => {
      if (row.number >= this.firstDataRow) {
        result.push(this.parseRow(row, columns));
      } else {
        this.verifyColumnsStructure(row, columns);
      }
    });
    return result;
  }
  verifyColumnsStructure(row, columns) {
    const values = row.values;
    Object.keys(columns).forEach((key) => {
      const recievedValue = values[columns[key].colIndex]?.toString();
      const expectedValue = columns[key].header;
      if (recievedValue !== expectedValue) {
        throw new InvalidStructureError("Incorrect structure", {
          cause: {
            expectedValue,
            recievedValue
          }
        });
      }
    });
  }
  parseRow(row, columns) {
    const values = row.values;
    const rowDataModel = {};
    Object.keys(columns).forEach((key) => {
      const value = values[columns[key].colIndex];
      if (this.isHyperLink(value)) {
        rowDataModel[key] = value?.text?.toString();
      } else {
        rowDataModel[key] = value?.toString() ?? null;
      }
    });
    return { ...rowDataModel, rowIndex: row.number.toString() };
  }
  isHyperLink(value) {
    return typeof value === "object" && Object.hasOwn(value, "text") && Object.hasOwn(value, "hyperlink");
  }
  setHeaderCellBorders(headerRow) {
    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  }
  setColumnValidation(sheet, colDef, maxDataRow) {
    const sheetColumn = sheet.getColumn(colDef.key);
    for (let rowIndex = this.firstDataRow; rowIndex <= maxDataRow; rowIndex++) {
      const cellWithValidation = sheet.getCell(rowIndex, sheetColumn.number);
      cellWithValidation.dataValidation = colDef.validation;
    }
  }
  reset() {
    this.workbook = new ExcelJS.Workbook();
  }
}
export {
  BaseExcelDocumentBuilder,
  InvalidStructureError
};
//# sourceMappingURL=BaseExcelDocumentBuilder.js.map
